import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

function PostEventCreatePrompt({ show, handleClose }) {
  const nagivate = useNavigate();
  const assignNow = () => {
    nagivate(`/admin/events/new/6/${show}/post_event_create`);
  };
  const skipAndAssignLater = () => {
    nagivate(`/admin/events/${show}`);
    handleClose();
  };
  return (
    <Modal show={Boolean(show)} onHide={handleClose} centered backdrop="static">
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id="event.postEventCreatePrompt" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Button variant="primary" onClick={assignNow}>
          <FormattedMessage id="event.managerAdd" />
        </Button>
        <Button variant="outline-danger" onClick={skipAndAssignLater}>
          <FormattedMessage id="event.managerSkip" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PostEventCreatePrompt;
